import React, { useState, useEffect } from "react";

import VoiceSelect from "../component/Dashboard/VoiceSelect";
import SpeechList from "../component/Dashboard/SpeechList";
import CategorySelect from "../component/Dashboard/CategorySelect";

import { CATDATA, STAGDATA } from "../utils/initData";

const msg = new SpeechSynthesisUtterance();

const Dashboard = (props) => {
  const [speeches, setSpeeches] = useState([]);
  const [currentCategory, setCurrentCategory] = useState("default");
  const [categories, setCategories] = useState([]);
  const [currentVoice, setCurrentVoice] = useState("male");

  useEffect(() => {
    if (localStorage.getItem("speeches") !== null) {
      setSpeeches(JSON.parse(localStorage.getItem("speeches")));
    } else {
      setSpeeches(STAGDATA);
      localStorage.setItem("speeches", JSON.stringify(STAGDATA));
    }

    if (localStorage.getItem("categories") !== null) {
      setCategories(JSON.parse(localStorage.getItem("categories")));
    } else {
      setCategories(CATDATA);
      localStorage.setItem("categories", JSON.stringify(CATDATA));
    }

    msg.voice = speechSynthesis
      .getVoices()
      .find((voice) => voice.name === "Google UK English Male");
    // msg.text = "Voice Ready.";

    // console.log("----> dashboard");
  }, []);

  const changeGender = (gender) => {
    msg.voice = speechSynthesis
      .getVoices()
      .find((voice) => voice.name === gender);

    setCurrentVoice(gender === "Google UK English Male" ? "male" : "female");
  };

  const changeCategory = (cat) => {
    setCurrentCategory(cat);
  };

  const speakMessage = (text) => {
    msg.text = text;

    speechSynthesis.speak(msg);
  };

  return (
    <div className="container">
      <VoiceSelect currentVoice={currentVoice} changeGender={changeGender} />
      <CategorySelect
        categories={categories}
        currentCategory={currentCategory}
        changeCategory={changeCategory}
      />
      <SpeechList
        currentCategory={currentCategory}
        speeches={speeches}
        speakMessage={speakMessage}
      />
    </div>
  );
};

export default Dashboard;
